import { AceIcon, SettingsIcon } from '../icons'

interface Props {
  open: boolean
}

export const FakeUserMenu = ({ open }: Props) => {
  document.body.className = document.body.className.replace(' data-tour-user-menu-open', '')
  if (open) document.body.className += ' data-tour-user-menu-open'

  return (
    <div data-tour='tour-fake-user-menu' className={`nav__user-menu ${open && 'nav__user-menu--open'}`}>
      <a className='nav__user-menu-item nav__user-menu-item--challenges' data-tour='my-challenges'>
        <span className='nav__user-menu-item-label'>My Challenges</span>
        <span className='nav__user-menu-item-count'>1</span>
      </a>
      <a className='nav__user-menu-item nav__user-menu-item--pins' data-tour='my-pins'>
        <span className='nav__user-menu-item-label'>My Pins</span>
        <span className='nav__user-menu-item-count'>5</span>
      </a>
      <a className='nav__user-menu-item'>
        <span className='nav__user-menu-item-label'>My Compass Profile</span>
        <span className='nav__user-menu-item-icon'>
          <SettingsIcon />
        </span>
      </a>
      <a className='nav__user-menu-item'>
        <span className='nav__user-menu-item-label'>Help</span>
        <span className='nav__user-menu-item-icon'>
          <AceIcon />
        </span>
      </a>
      <a className='nav__user-menu-item'>
        <span className='nav__user-menu-item-label'>Sign Out</span>
      </a>
    </div>
  )
}
